import {BaseModel} from '../../base/models/base-model.model';

export class UnitModel extends BaseModel {
  /**
   * Unit Account Code
   */
  private _accountCode?: string;
  /**
   * Unit Id
   */
  private _code?: string;
  /**
   * Unit Customer Code
   */
  private _customerCode?: string;
  /**
   * Unit Description
   */
  private _description?: string;
  private _father?: UnitModel;
  private _structure?: Array<UnitModel>;
  /**
   * Unit Account Code (Inheritance)
   */
  private _treeAccountCode?: string;
  /**
   * Unit Customer Code (Inheritance)
   */
  private _treeCustomerCode?: string;

  constructor(accountCode?: string, code?: string, customerCode?: string, description?: string, father?: UnitModel, structure?: Array<UnitModel>, treeAccountCode?: string, treeCustomerCode?: string) {
    super();
    this._accountCode = accountCode;
    this._code = code;
    this._customerCode = customerCode;
    this._description = description;
    this._father = father;
    this._structure = structure;
    this._treeAccountCode = treeAccountCode;
    this._treeCustomerCode = treeCustomerCode;
  }

  get accountCode(): string {
    return this._accountCode;
  }

  set accountCode(value: string) {
    this._accountCode = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get customerCode(): string {
    return this._customerCode;
  }

  set customerCode(value: string) {
    this._customerCode = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get father(): UnitModel {
    return this._father;
  }

  set father(value: UnitModel) {
    this._father = value;
  }

  get structure(): Array<UnitModel> {
    return this._structure;
  }

  set structure(value: Array<UnitModel>) {
    this._structure = value;
  }

  get treeAccountCode(): string {
    return this._treeAccountCode;
  }

  set treeAccountCode(value: string) {
    this._treeAccountCode = value;
  }

  get treeCustomerCode(): string {
    return this._treeCustomerCode;
  }

  set treeCustomerCode(value: string) {
    this._treeCustomerCode = value;
  }
}
